import { useCallback } from 'react'
import api from '../../services/api'

const useQueues = () => {
  const findAll = useCallback(async (params = {}) => {
    const { data } = await api.get('/queue', { params })
    return data
  }, [])

  return { findAll }
}

export default useQueues
